import { Component } from '@angular/core';
import Swal from 'sweetalert2';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NotificacoesDetalhesComponent } from '../notificacoes-detalhes/notificacoes-detalhes.component';

@Component({
  selector: 'app-notificacoes-historico-dialog',
  standalone: false,
  templateUrl: './notificacoes-historico-dialog.component.html',
  styleUrl: './notificacoes-historico-dialog.component.css'
})
export class NotificacoesHistoricoDialogComponent {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<NotificacoesHistoricoDialogComponent>) { }

  close() {
    this.dialogRef.close();
  }

  notifications = [
    {
      type: 'success',
      typeLabel: 'Sucesso',
      title: 'Novo módulo disponível',
      subtitle: 'Sistema atualizado',
      text: 'O módulo "Editor da Home Page" foi adicionado ao sistema e está disponível para uso.',
      date: '22/01/2025',
      time: '14:30',
      hasDetails: true
    },
    {
      type: 'warning',
      typeLabel: 'Aviso',
      title: 'Atualização de permissões',
      subtitle: 'Ação necessária',
      text: 'As permissões do usuário "Maria Silva" foram modificadas.',
      date: '22/01/2025',
      time: '11:15',
      hasDetails: true
    },
    {
      type: 'info',
      typeLabel: 'Info',
      title: 'Backup concluído',
      subtitle: 'Sistema',
      text: 'O backup automático dos dados foi concluído com sucesso às 03:00.',
      date: '22/01/2025',
      time: '03:00',
      hasDetails: false
    },
    {
      type: 'info',
      typeLabel: 'Info',
      title: 'Dados Atricon atualizados',
      subtitle: 'Conformidade',
      text: 'Novos critérios da cartilha Atricon foram adicionados ao sistema.',
      date: '22/01/2025',
      time: '03:00',
      hasDetails: true
    },
    {
      type: 'danger',
      typeLabel: 'Alerta',
      title: 'Atenção: Prazo próximo',
      subtitle: 'Prestação de Contas',
      text: 'O prazo para envio da prestação de contas trimestral termina em 5 dias.',
      date: '21/01/2025',
      time: '09:00',
      hasDetails: true
    }
  ];

  abrirDetalhes(notificacoes: any) {
    this.dialog.open(NotificacoesDetalhesComponent, {
      data: { notificacao: notificacoes },
      maxWidth: '950px',
      maxHeight: '100vh',
      autoFocus: false
    });
  }

}
